<template>
  <div>
    <b-modal
      v-if="id == 'coupon-detail'"
      :id="'couponDetailModal' + '_'"
      ref="globalModal"
      size="lg"
      hide-footer
      v-model="modalShown"
      @hide="handleHide"
      static
    >
      <coupon-detail-modal
        :couponId="mergedOptions.couponId"
        :position="mergedOptions.position"
      ></coupon-detail-modal>
    </b-modal>

    <b-modal
      v-if="id == 'sparkle'"
      :id="id"
      size="lg"
      ref="sparkle"
      v-model="modalShown"
      @hide="handleHide"
      hide-footer
      static
    >
      <modal-sparkle parentModalRef="sparkle"></modal-sparkle>
    </b-modal>

    <b-modal
      v-if="id == 'product-detail'"
      :id="'productDetailsModal' + mergedOptions.productId"
      ref="globalModal"
      hide-footer
      modal-class="product-details"
      size="product-details"
      v-model="modalShown"
      @hide="handleHide"
      static
    >
      <product-details-modal
        :productId="mergedOptions.productId"
        :bucket="mergedOptions.bucket"
      ></product-details-modal>
    </b-modal>

    <b-modal
      v-if="id == 'email-sharing'"
      id="email-sharing-modal"
      ref="globalModal"
      modal-title="Email to a Friend"
      hide-footer
      v-model="modalShown"
      @hide="handleHide"
      static
    >
      <email-sharing-modal :coupon="mergedOptions.coupon"></email-sharing-modal>
    </b-modal>

    <!-- Representative Product Modal -->
    <b-modal
      v-if="id == 'representative-product-modal'"
      id="representative-product-modal"
      ref="representative-product-modal"
      ok-only
      size="sm"
      v-model="modalShown"
      @hide="handleHide"
      static
      lazy
      @shown="getModalContent('covid_representative_product_directions')"
    >
      <template v-slot:modal-title>
        <div v-html="modalData.displayName"></div>
      </template>

      <div v-html="modalData.body"></div>
    </b-modal>

    <b-modal
      v-if="id == 'another-modal'"
      v-model="modalShown"
      ref="globalModal"
      static
      >Another Modal
      <br />
      Options: {{ options }}
    </b-modal>
  </div>
</template>

<script>
import CouponDetailModal from "./CouponDetailModal";
import ProductDetails from "./product/ProductDetails";
import ModalSparkle from "./cart/ModalSparkle.vue";
import EmailSharingModal from "./sharing/EmailSharingModal";

export default {
  name: "GlobalModals",
  props: {
    options: {}
  },
  components: {
    "coupon-detail-modal": CouponDetailModal,
    "product-details-modal": ProductDetails,
    "email-sharing-modal": EmailSharingModal,
    ModalSparkle
  },
  data() {
    return {
      isLoaded: false,
      modalData: {
        displayName: "",
        body: ""
      }
    };
  },
  computed: {
    id() {
      if (typeof this.$route != "undefined") {
        return this.$route.query.modalId;
      } else {
        return this.$store.state.profile.globalModals.id;
      }
    },
    mergedOptions() {
      if (typeof this.$route != "undefined") {
        return this.$route.query;
      } else {
        return this.$store.state.profile.globalModals.options;
      }
    },
    modalShown: {
      get() {
        return this.$store.state.profile.globalModals.shown;
      },
      set(value) {
        this.$store.commit("profile/TOGGLE_GLOBAL_MODAL", value);
      }
    }
  },
  methods: {
    getModalContent: function(id) {
      // Gets representative product message from BCC during COVID-19
      // Rewritten to not use ajax
      var data = _.get(heb, `data.message.${id}`, false)
      if(data){
        this.modalData = data;
        this.modalData.loaded = true;
      }
    },
    handleHide(bvEvt) {
      // Close or go back()?

      // vue router scenario
      if (this.$route) {
        if (this.$route.query.closeAction === "back") {
          history.back();
          return;
        }

        // if the user clicked back button, go history.back(), if they clicked X or esc close and also fix the url.
        if (
          bvEvt.trigger == "header-close" ||
          bvEvt.trigger == "backdrop" ||
          bvEvt.trigger == "esc"
        ) {
          // close modal and fix URL
          this.$router.replace(this.$route.path);
        } else {
          history.back();
        }
      } else {
        //when outside of vue
        //this is exlcusively for the coupon details modal, as there is no other true modal in modal scenario outside of Vue right now (timeslot modal in modal is self contained)
        if (
          _.get(VueStore, '$store.state.profile.globalModals.options.closeAction', false) ===
          "back"
        ) {
          var previousModalId =
            VueStore.$store.state.profile.globalModals.options.coupon.couponId;

          // reopen old modal
          //setTimeout to prevent Bootstrap Vue funkiness
          setTimeout(function() {
            VueStore.$store.commit("profile/OPEN_MODAL", {
              id: "coupon-detail",
              options: { couponId: previousModalId }
            });
          }, 200);
        }
      }
      // reset $store
      this.$store.commit("profile/CLOSE_MODAL");
    }
  },
  mounted: function() {
    this.modalShown = true;
  },
  watch: {
    $route(to, from) {
      // console.log('route changed, to:', to, 'from:', from, this.$route)
      if (
        typeof this.$route.query !== "undefined" &&
        typeof this.$route.query.modalId !== "undefined"
      ) {
        // we need to open a modal
        // console.log("we need to open a modal,", this.$route.query.modalId);

        // close any open modal first
        // if (typeof this.$refs.globalModal !== "undefined") {
        //   this.$refs.globalModal.hide();
        // }

        this.$store.commit("profile/OPEN_MODAL", {
          id: this.$route.query.modalId,
          queryParams: this.$route.query
        });

        if (typeof this.$refs.globalModal !== "undefined") {
          this.$refs.globalModal.show();
        }
      }
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped></style>

<docs>
    Usage

    hupOpenModal() is a wrapper to push a new URL when in the single page app, to allow forward/back buttons. It doesn't work for the non-spa.

    You can launch non-spa modals using the $store:

    VueStore.$store.commit('profile/OPEN_MODAL', {
      id: 'coupon-detail',  
      options: {couponId: couponId}
    })
</docs>
